export default "__VITE_ASSET__8lcnjOTQ__"